import { useTexts } from "Store/texts";
import { NewCustomerResponse } from "Store/userIdentification/userIdentificationInterfaces";
import { isDefined } from "Utils/functions";
import { getAgeFromDate } from "Validation/dateValidaton";
import React from "react";
import { getYearMonthDayFromDate } from "./utils";

interface Props {
  newCustomerResponse: NewCustomerResponse;
}

export const UserDateOfBirth = ({
  newCustomerResponse,
}: Props): React.ReactElement | null => {
  const fmsTexts = useTexts();
  if (!isDefined(newCustomerResponse.dateOfBirth)) {
    return null;
  }
  const { dateOfBirth } = newCustomerResponse;

  const [year, month, day] = getYearMonthDayFromDate(dateOfBirth);
  const age = getAgeFromDate(new Date(dateOfBirth));

  return (
    <>
      <span>
        <b>{fmsTexts.domain["signedInUserInfo.born.label"]}</b>{" "}
        {`${day}.${month}.${year}`}
      </span>
      <span>
        <b>{fmsTexts.domain["signedInUserInfo.age.label"]}</b> {`${age} år`}
      </span>
    </>
  );
};
